<template>
  <div class="relative mt-3 flex flex-col items-center space-y-1">
    <div class="flex h-32 max-w-[24px] items-end">
      <div class="flex h-20 items-end">
        <div
          :id="search.id.toString()"
          class="relative flex max-h-20 min-h-[24px] w-6 items-center justify-center rounded-t-[4px] transition-[height] duration-300"
          :class="[
            `columnElement${direction}`,
            {
              'bg-situational-lightgrey':
                (isDefaultColumn || isUnknownPrice) && !search.isActive,
            },
            { 'bg-background-positive-primary': search.isMinPrice },
            { 'bg-situational-grey': isUnknownPrice && search.isActive },
            { 'bg-background-info-primary': isDefaultActiveColumn },
          ]"
          :style="{ height: `${columnHeight + 24}px` }"
          @click="emit('onClick', search.id)"
        >
          <ColumnTooltip
            v-if="search.isActive"
            :price="search.price?.toString()"
            :is-min-price="Boolean(search.isMinPrice)"
            :is-unknown-price="isUnknownPrice"
          />
          <span
            v-if="isUnknownPrice"
            class="text-xs font-medium"
            :class="
              search.isActive ? 'text-static-white' : 'text-situational-grey'
            "
          >
            ?
          </span>
        </div>
      </div>
    </div>
    <div class="flex flex-col items-center">
      <p
        class="text-2xs uppercase"
        :class="[
          {
            'text-text-neutral-quaternary': !search.isActive || isUnknownPrice,
          },
          {
            'text-text-positive-primary': search.isMinPrice && search.isActive,
          },
          { 'text-text-info-primary': isDefaultActiveColumn },
        ]"
      >
        {{ dateUtils.getPrettyDayOfWeek(search.departureDate) }}
      </p>
      <p
        class="text-xs font-medium"
        :class="[
          { 'text-text-neutral-primary': !search.isActive },
          {
            'text-text-positive-primary': search.isMinPrice && search.isActive,
          },
          { 'text-text-neutral-quaternary': isUnknownPrice && search.isActive },
          { 'text-text-info-primary': isDefaultActiveColumn },
        ]"
      >
        {{ dateUtils.format(search.departureDate, 'D') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { dateUtils } from 'shared';

  import ColumnTooltip from './GraphTooltip.vue';
  import type { MappedRoundTripNearestSearch } from '../types';

  const props = defineProps<{
    search: MappedRoundTripNearestSearch;
    direction: string;
    columnHeight: number;
  }>();

  const emit = defineEmits<{ onClick: [id: number] }>();

  const isDefaultColumn = computed(() => {
    return (
      !props.search.isMinPrice &&
      props.search.price !== null &&
      !props.search.isActive
    );
  });
  const isDefaultActiveColumn = computed(() => {
    return (
      !props.search.isMinPrice &&
      props.search.price !== null &&
      props.search.isActive
    );
  });
  const isUnknownPrice = computed(() => props.search.price === null);
</script>
